import React from 'react';
import HeadingBlock from '$/components/global/heading';

const Admin: React.FC = () => {
  return (
    <React.Fragment>
      <section>
        <HeadingBlock title="Admin" titleOnly />
      </section>
    </React.Fragment>
  );
};

export default Admin;
